import { z } from 'zod/v4';

import { normalizeIndentWidgetArgs } from './indent-widget-args.normalization';
import { indentWidgetDataSchema } from './partial-indent-widget-data.schema';

/**
 * `data` is the exact same `indentWidgetDataSchema` `create_indent_widget` uses, kept identical on
 * purpose (mirrors button/text/image's own create/update field-surface parity reasoning). An empty
 * `data` still parses successfully — the execute()/mutation layer is what rejects a true no-op
 * patch, since "no recognized fields" needs an actionable error message, not a generic schema
 * validation failure.
 */
const updateIndentWidgetObjectSchema = z.object({
    widgetId: z.string().describe('Id of the indent (spacer) widget to update.'),
    data: indentWidgetDataSchema.describe(
        'Partial patch — only the fields you provide are changed, everything else is left as-is.'
    ),
});

export const updateIndentWidgetArgsSchema = z.preprocess(normalizeIndentWidgetArgs, updateIndentWidgetObjectSchema);
